import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Button from '@ids-ts/button';
import styles from './Modal.module.scss';
/**
 * Modal component for displaying overlay content
 * @param {ModalProps} props - Component props
 * @returns {JSX.Element | null} Modal component
 */
const Modal = ({ isOpen, onClose, title, children, primaryButtonText, secondaryButtonText, onPrimaryClick, onSecondaryClick, }) => {
    // Handle ESC key press
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    return (_jsx("div", { className: styles.overlay, onClick: onClose, children: _jsxs("div", { className: styles.modal, onClick: (e) => e.stopPropagation(), role: "dialog", "aria-modal": "true", "aria-labelledby": title ? 'modal-title' : undefined, children: [title && (_jsx("h2", { id: "modal-title", className: styles.title, children: title })), _jsx("div", { className: styles.content, children: children }), (primaryButtonText || secondaryButtonText) && (_jsxs("div", { className: styles.actions, children: [secondaryButtonText && (_jsx(Button, { className: styles.secondaryButton, onClick: onSecondaryClick || onClose, children: secondaryButtonText })), primaryButtonText && (_jsx(Button, { className: styles.primaryButton, onClick: onPrimaryClick, children: primaryButtonText }))] }))] }) }));
};
export default Modal;
